import { getDefaultStorePatchForSchemaParam } from 'Pods/ThreeDStudio/Services/getDefaultStorePatchForSchemaParam'
import { resolveActivePolycountRange } from 'Pods/ThreeDStudio/Services/resolveActivePolycountRange'

/**
 * Fills an empty target polycount the way schema normalization would: the Low/Medium/High
 * tier picks the range bound, falling back to the range default. Unlimited runs reopen
 * without a stored polycount, and normalization does not rerun when the engine settings
 * stay the same, so turning Unlimited off would otherwise send an empty target.
 *
 * @param {Object} modelSettings - The model settings to inspect.
 * @param {Object} generationModelSchema - The generation schema the settings belong to.
 * @returns {Object} A { targetPolycount } patch, or an empty object.
 */
export function emptyTargetPolycountPatch(modelSettings, generationModelSchema) {
  const { targetPolycount, polygonType, isSmartLowPoly } = modelSettings || {}
  if (targetPolycount != null && targetPolycount !== '') {
    return {}
  }

  const range = resolveActivePolycountRange(generationModelSchema, { polygonType, isSmartLowPoly })

  return getDefaultStorePatchForSchemaParam('target_polycount', range, modelSettings) || {}
}
